/* Quick-add + stepper de quantité des cartes produit MonSacPoubelle.
   Chargé par msp-bestsellers et la grille des collections — garde anti-double-init. */
(function () {
  'use strict';
  if (window.__mspProductCardJs) return;
  window.__mspProductCardJs = true;

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubbleWrap = document.querySelector('#cart-icon-bubble');
        if (!bubbleWrap) return;
        var bubble = bubbleWrap.querySelector('.cart-count-bubble');
        if (!bubble && cart.item_count > 0) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          bubbleWrap.appendChild(bubble);
        }
        if (bubble) {
          var span = bubble.querySelector('span[aria-hidden]');
          if (span) span.textContent = cart.item_count;
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-msp-qty-minus]');
    var plus = e.target.closest('[data-msp-qty-plus]');
    if (minus || plus) {
      var input = (minus || plus).parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + (plus ? 1 : -1));
      return;
    }
    var btn = e.target.closest('[data-msp-quick-add]');
    if (!btn || btn.disabled) return;
    var buyRow = btn.closest('.msp-bs__buy');
    var qtyInput = buyRow && buyRow.querySelector('.msp-bs__qty input');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: qty,
        sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        btn.querySelector('.msp-bs__add-label').hidden = true;
        btn.querySelector('.msp-bs__add-done').hidden = false;
        btn.classList.add('is-done');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: data.sections });
        } else {
          updateCartCount();
        }
        setTimeout(function () {
          btn.querySelector('.msp-bs__add-label').hidden = false;
          btn.querySelector('.msp-bs__add-done').hidden = true;
          btn.classList.remove('is-done');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () { btn.disabled = false; });
  });
})();
